// extracted by mini-css-extract-plugin
module.exports = {"container":"Segments_container__ikNeJ"};